var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63b42ac92c0f729a4011eff7c986d1b1.js').default;export default
        Object.assign({}, scope_0 )
    